var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable no-console */
import { useState, useCallback, useRef } from 'react';
import { useFetch } from '../useFetch';
import { EventError, } from '../../types/index';
import { allDayCalendarDateFromApi, allDayMomentAtStartOfCalendarDate, } from '../../utils/allDayDateUtils';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { EventSeriesOption, } from './useEventTypes';
import { buildUpdateEventRequestBody } from '../../utils/payloadBuilders';
import { buildCancelEventAsSpacePath } from '../../utils/asSpaceCancel';
var isPersonalCalendarError = function (message) {
    var lower = message.toLowerCase();
    return (lower.includes('personal calendar integration') &&
        lower.includes('request-only'));
};
var isAbortError = function (error) {
    return error instanceof Error && error.name === 'AbortError';
};
var httpStatusFromFetchError = function (error) {
    var response = error === null || error === void 0 ? void 0 : error.response;
    return typeof (response === null || response === void 0 ? void 0 : response.status) === 'number' ? response.status : undefined;
};
var spaceBookingPermissionsInclude = 'permissions:operations(' +
    'spaces:book|events:manage|events:read|spaces:bypass_booking_policies|spaces:bypass_autounbook' +
    ')';
var spaceSettingsInclude = 'settings:slugs(' +
    'event-confirmation-window|' +
    'space-reservation-advanced-booking-threshold|' +
    'space-reservation-max-length|' +
    'space-reservation-recurrence-allowed|' +
    'enable-space-reservation-visibility' +
    ')';
export function decorateEvent(event, timezone) {
    var startTime = moment.tz(event.start.date_time, timezone);
    var endTime = moment.tz(event.end.date_time, timezone);
    // All-day API datetimes are UTC midnights encoding calendar dates, not instants.
    if (event.is_all_day) {
        startTime = allDayMomentAtStartOfCalendarDate(allDayCalendarDateFromApi(event.start.date_time), timezone);
        endTime = allDayMomentAtStartOfCalendarDate(allDayCalendarDateFromApi(event.end.date_time), timezone);
    }
    return __assign(__assign({}, event), { startTime: startTime, endTime: endTime, duration: moment.duration(endTime.diff(startTime)) });
}
export var useEventApi = function (_a) {
    var 
    /* @TODO Split away this hook from the event details context. Then remove this onerror prop */
    onError = _a.onError, apiUrl = _a.apiUrl, baseApiUrl = _a.baseApiUrl, integrationsServiceUrl = _a.integrationsServiceUrl, currentOrg = _a.currentOrg, tenantId = _a.tenantId, accessToken = _a.accessToken;
    var _b = __read(useState(false), 2), creatingEvent = _b[0], setCreatingEvent = _b[1];
    var _c = __read(useState(false), 2), updatingEvent = _c[0], setUpdatingEvent = _c[1];
    /* @TODO This should be coming from the context */
    var _d = __read(useState(null), 2), eventError = _d[0], setEventError = _d[1];
    var abortControllerRef = useRef(new AbortController());
    var onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    var _e = useFetch(accessToken), get = _e.get, post = _e.post, update = _e.update, deleteRecord = _e.delete;
    var t = useTranslation('meetingRooms').t;
    var tenantHeaders = useCallback(function () { return ({
        'tenant-id': "".concat(tenantId),
    }); }, [tenantId]);
    var fetchEvent = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var includes, response, event_1, error_1;
        var _c;
        var timezone = _b.timezone, id = _b.id;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (abortControllerRef.current.signal.aborted) {
                        return [2 /*return*/];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    includes = [
                        'invitees.user',
                        'integrations',
                        'space_invitees.invitee_event',
                        'space_invitees.space',
                        'space_invitees.space.location',
                        'space_invitees.space.level',
                        'space_invitees.space.calendar',
                        'space_invitees.space.space_amenities',
                        "space_invitees.space.".concat(spaceSettingsInclude),
                        "space_invitees.space.".concat(spaceBookingPermissionsInclude),
                        'reservation_approval',
                        'event_permissions',
                    ].join(',');
                    return [4 /*yield*/, get("".concat(baseApiUrl, "/v2.0/events/").concat(id, "?include=").concat(includes), undefined, {
                            headers: __assign({}, tenantHeaders()),
                            signal: abortControllerRef.current.signal,
                        })];
                case 2:
                    response = _d.sent();
                    event_1 = response.data;
                    return [2 /*return*/, decorateEvent(event_1, timezone)];
                case 3:
                    error_1 = _d.sent();
                    if (!isAbortError(error_1)) {
                        (_c = onErrorRef.current) === null || _c === void 0 ? void 0 : _c.call(onErrorRef, new Error(t('errors.failed_to_fetch_event', { error: String(error_1) })));
                        if (!abortControllerRef.current.signal.aborted) {
                            setEventError({
                                error: [error_1.message],
                                errorType: EventError.FETCH,
                            });
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, undefined];
            }
        });
    }); }, [get, baseApiUrl, t, tenantHeaders]);
    var fetchSpace = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var includes, response, space, error_2;
        var _c;
        var spaceId = _b.spaceId;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (abortControllerRef.current.signal.aborted) {
                        return [2 /*return*/];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    includes = [
                        'space_amenities',
                        spaceSettingsInclude,
                        spaceBookingPermissionsInclude,
                        'calendar',
                    ].join(',');
                    return [4 /*yield*/, get("".concat(apiUrl, "/spaces/").concat(spaceId, "?include=").concat(includes), undefined, {
                            headers: __assign({}, tenantHeaders()),
                            signal: abortControllerRef.current.signal,
                        })];
                case 2:
                    response = _d.sent();
                    space = response.data;
                    return [2 /*return*/, space];
                case 3:
                    error_2 = _d.sent();
                    if (!isAbortError(error_2)) {
                        (_c = onErrorRef.current) === null || _c === void 0 ? void 0 : _c.call(onErrorRef, new Error(t('errors.failed_to_fetch_event', { error: String(error_2) })));
                        if (!abortControllerRef.current.signal.aborted) {
                            setEventError({
                                error: [error_2.message],
                                errorType: EventError.FETCH,
                            });
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, undefined];
            }
        });
    }); }, [get, apiUrl, t, tenantHeaders]);
    var deleteEvent = useCallback(function (eventId, eventSeriesOption) { return __awaiter(void 0, void 0, void 0, function () {
        var seriesOption, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    seriesOption = function () {
                        switch (eventSeriesOption) {
                            case EventSeriesOption.THIS_EVENT:
                                return '';
                            case EventSeriesOption.THIS_AND_FOLLOWING_EVENTS:
                                return '/series/this-and-following';
                            case EventSeriesOption.ALL_EVENTS:
                                return '/series';
                        }
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteRecord("".concat(baseApiUrl, "/v2.0/events/").concat(eventId).concat(seriesOption()), {
                            headers: __assign({}, tenantHeaders()),
                            signal: abortControllerRef.current.signal,
                        })];
                case 2:
                    _b.sent();
                    return [2 /*return*/, true];
                case 3:
                    error_3 = _b.sent();
                    if (!isAbortError(error_3)) {
                        (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(t('errors.failed_to_delete_event', { error: String(error_3) })));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, false];
            }
        });
    }); }, [deleteRecord, baseApiUrl, abortControllerRef, t, tenantHeaders]);
    var cancelEventAsSpace = useCallback(function (spaceId, eventId, eventSeriesOption) { return __awaiter(void 0, void 0, void 0, function () {
        var error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteRecord("".concat(baseApiUrl).concat(buildCancelEventAsSpacePath(spaceId, eventId, eventSeriesOption)), {
                            headers: __assign({}, tenantHeaders()),
                            signal: abortControllerRef.current.signal,
                        })];
                case 1:
                    _b.sent();
                    return [2 /*return*/, true];
                case 2:
                    error_4 = _b.sent();
                    if (!isAbortError(error_4)) {
                        (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(t('errors.failed_to_delete_event', { error: String(error_4) })));
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    }); }, [deleteRecord, baseApiUrl, abortControllerRef, t, tenantHeaders]);
    var fetchEditSyncedEvents = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_5;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!currentOrg) {
                        return [2 /*return*/, undefined];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, get("".concat(apiUrl, "/organizations/").concat(currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id, "/settings/edit-synced-events"))];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, response.data.value];
                case 3:
                    error_5 = _b.sent();
                    (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(t('errors.failed_to_fetch_edit_synced_events_setting', {
                        error: String(error_5),
                    })));
                    return [2 /*return*/, undefined];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [get, apiUrl, currentOrg, t]);
    var getVideoIntegration = useCallback(function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var orgId, response, error_6;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    orgId = currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id;
                    if (!integrationsServiceUrl) {
                        return [2 /*return*/, undefined];
                    }
                    if (!orgId || !userId || abortControllerRef.current.signal.aborted) {
                        return [2 /*return*/, undefined];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, get("".concat(integrationsServiceUrl, "/organizations/").concat(orgId, "/users/").concat(userId, "/integrations"), {
                            resource_type: 'event',
                        }, { signal: abortControllerRef.current.signal })];
                case 2:
                    response = _c.sent();
                    return [2 /*return*/, (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : undefined];
                case 3:
                    error_6 = _c.sent();
                    if (!isAbortError(error_6)) {
                        (_b = onErrorRef.current) === null || _b === void 0 ? void 0 : _b.call(onErrorRef, new Error(t('video_integration.error', { error: String(error_6) })));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, undefined];
            }
        });
    }); }, [get, currentOrg, integrationsServiceUrl, t]);
    var confirmEvent = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var error_7;
        var _c;
        var eventId = _b.eventId, userId = _b.userId;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, update("".concat(apiUrl, "/events/").concat(eventId, "/confirmation"), {
                            user_id: userId,
                        }, {
                            headers: __assign(__assign({}, tenantHeaders()), { 'content-type': 'application/json' }),
                            method: 'PUT',
                            signal: abortControllerRef.current.signal,
                        })];
                case 1:
                    _d.sent();
                    return [2 /*return*/, true];
                case 2:
                    error_7 = _d.sent();
                    if (!isAbortError(error_7)) {
                        (_c = onErrorRef.current) === null || _c === void 0 ? void 0 : _c.call(onErrorRef, new Error(t('errors.failed_to_confirm_event', { error: String(error_7) })));
                    }
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [apiUrl, t, tenantHeaders, update]);
    var fetchLocationSettings = useCallback(function (locationId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_8;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, get("".concat(apiUrl, "/locations/").concat(locationId, "/settings"), {
                            page: '1',
                            per_page: '150',
                        }, {
                            headers: __assign({}, tenantHeaders()),
                            signal: abortControllerRef.current.signal,
                        })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data.reduce(function (settings, setting) {
                            settings[setting.slug] = setting.value;
                            return settings;
                        }, {})];
                case 2:
                    error_8 = _b.sent();
                    if (!isAbortError(error_8)) {
                        (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(t('errors.failed_to_fetch_location_settings', {
                            error: String(error_8),
                        })));
                    }
                    return [2 /*return*/, undefined];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [apiUrl, get, t, tenantHeaders]);
    /* @TODO Aug 27th: Removed amplitude tracking here */
    var createEvent = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var headers, eventPayload, response, error_9, rawMessage, isPersonalCalendarErr, displayMessage;
        var title = _b.title, description = _b.description, space_invitees = _b.space_invitees, startTime = _b.startTime, endTime = _b.endTime, timezone = _b.timezone, invitees = _b.invitees, attendeeCount = _b.attendeeCount, isPrivate = _b.isPrivate, isAllDayEvent = _b.isAllDayEvent, _c = _b.preConfirm, preConfirm = _c === void 0 ? false : _c, includedIntegrations = _b.includedIntegrations, _d = _b.calendarType, calendarType = _d === void 0 ? '' : _d, _e = _b.calendarMailboxAddress, calendarMailboxAddress = _e === void 0 ? '' : _e, uid = _b.uid, isRequestOnlySpace = _b.isRequestOnlySpace, recurrence = _b.recurrence;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    setCreatingEvent(true);
                    setEventError(null);
                    /* Can't create an event without a UID */
                    if (!uid) {
                        setEventError({
                            error: [t('errors.event_uid_required')],
                            errorType: EventError.CREATE,
                        });
                        return [2 /*return*/, undefined];
                    }
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, 4, 5]);
                    headers = __assign(__assign({}, tenantHeaders()), { 'Content-Type': 'application/json' });
                    eventPayload = {
                        calendar_type: calendarType,
                        calendar_mailbox_address: calendarMailboxAddress,
                        start: {
                            time_zone: timezone,
                            date_time: startTime,
                        },
                        end: {
                            time_zone: timezone,
                            date_time: endTime,
                        },
                        title: title,
                        description: description,
                        /* @TODO What location should we use here? */
                        // location: space.name,
                        uid: uid,
                        is_all_day: isAllDayEvent,
                        visibility: isPrivate ? 'private' : 'default',
                        pre_confirm: preConfirm,
                        recurrence: recurrence ? [recurrence.toString()] : [],
                        invitees: invitees,
                        /* invitee_count if has a request only space */
                        /* Can only have 1 request only space */
                        invitee_count: isRequestOnlySpace ? attendeeCount : undefined,
                        space_invitees: space_invitees === null || space_invitees === void 0 ? void 0 : space_invitees.map(function (space) {
                            var _a;
                            return ({
                                space_id: space.id,
                                desired_buffers: (_a = space.desired_buffers) !== null && _a !== void 0 ? _a : {
                                    before_duration: null,
                                    after_duration: null,
                                },
                            });
                        }),
                        integration_ids: includedIntegrations,
                    };
                    return [4 /*yield*/, post("".concat(baseApiUrl, "/v2.0/events"), eventPayload, { headers: headers })];
                case 2:
                    response = _f.sent();
                    if (!response) {
                        setEventError({
                            error: [t('errors.failed_to_create_event')],
                            errorType: EventError.CREATE,
                        });
                        return [2 /*return*/, undefined];
                    }
                    return [2 /*return*/, {
                            data: response.data,
                            meta: response.meta,
                        }];
                case 3:
                    error_9 = _f.sent();
                    rawMessage = error_9 instanceof Error ? error_9.message : String(error_9);
                    isPersonalCalendarErr = isPersonalCalendarError(rawMessage);
                    displayMessage = isPersonalCalendarErr
                        ? t('errors.personal_calendar_required_for_request_only_space')
                        : rawMessage;
                    setEventError({
                        error: [displayMessage],
                        errorType: EventError.CREATE,
                        isPersonalCalendarError: isPersonalCalendarErr,
                    });
                    return [2 /*return*/, undefined];
                case 4:
                    setCreatingEvent(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [setCreatingEvent, setEventError, baseApiUrl, t, post, tenantHeaders]);
    var updateInviteeCount = function (eventId, inviteeCount) { return __awaiter(void 0, void 0, void 0, function () {
        var error_10;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, update("".concat(apiUrl, "/events/").concat(eventId, "/approvals"), {
                            invitee_count: inviteeCount,
                        }, {
                            headers: __assign(__assign({}, tenantHeaders()), { 'content-type': 'application/json' }),
                            method: 'PATCH',
                            signal: abortControllerRef.current.signal,
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_10 = _b.sent();
                    if (!isAbortError(error_10)) {
                        (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(t('errors.failed_to_update_invitee_count', {
                            error: String(error_10),
                        })));
                        throw error_10;
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var approveEventRequest = function (eventId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_11, forbidden;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, update("".concat(apiUrl, "/events/").concat(eventId, "/approvals"), {
                            approved: true,
                        }, {
                            headers: __assign(__assign({}, tenantHeaders()), { 'content-type': 'application/json' }),
                            method: 'PATCH',
                            signal: abortControllerRef.current.signal,
                        })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_11 = _b.sent();
                    if (!isAbortError(error_11)) {
                        forbidden = httpStatusFromFetchError(error_11) === 403;
                        (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(forbidden
                            ? t('errors.approve_reservation_forbidden')
                            : t('errors.failed_to_approve_event_request', {
                                error: String(error_11),
                            })));
                        throw error_11;
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var rejectEventRequest = function (eventId, approvalNotes) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_12, forbidden;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, update("".concat(apiUrl, "/events/").concat(eventId, "/approvals"), {
                            approved: false,
                            approval_notes: approvalNotes,
                        }, {
                            headers: __assign(__assign({}, tenantHeaders()), { 'content-type': 'application/json' }),
                            method: 'PATCH',
                            signal: abortControllerRef.current.signal,
                        })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_12 = _b.sent();
                    if (!isAbortError(error_12)) {
                        forbidden = httpStatusFromFetchError(error_12) === 403;
                        (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(forbidden
                            ? t('errors.reject_reservation_forbidden')
                            : t('errors.failed_to_reject_event_request', {
                                error: String(error_12),
                            })));
                        throw error_12;
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Updates the logged-in person's RSVP on a calendar-synced event invitee row.
     */
    var rsvpForInvitee = useCallback(function (eventId, inviteeEmail, responseStatus, comment) { return __awaiter(void 0, void 0, void 0, function () {
        var error_13;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (abortControllerRef.current.signal.aborted) {
                        return [2 /*return*/, false];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, post("".concat(apiUrl, "/events/").concat(eventId, "/invitees/").concat(encodeURIComponent(inviteeEmail), "/rsvp"), {
                            response_status: responseStatus,
                            comment: comment,
                        }, {
                            headers: __assign(__assign({}, tenantHeaders()), { 'content-type': 'application/json' }),
                            signal: abortControllerRef.current.signal,
                        })];
                case 2:
                    _b.sent();
                    return [2 /*return*/, true];
                case 3:
                    error_13 = _b.sent();
                    if (!isAbortError(error_13)) {
                        (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(t('errors.failed_to_update_person_rsvp', {
                            error: String(error_13),
                        })));
                    }
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [post, apiUrl, t, tenantHeaders]);
    /**
     * Updates the RSVP status of an invitee for an event.
     * This is used to change the reservation status of a space invitee.
     * This then makes the space available for booking again effectively deleting the invitee from the event.
     *
     * @param eventId - The ID of the event
     * @param inviteeId - The ID of the invitee
     * @returns Promise<boolean> - Returns true if successful, false otherwise
     */
    var removeSpaceInvitee = useCallback(function (eventId, inviteeId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_14;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (abortControllerRef.current.signal.aborted) {
                        return [2 /*return*/, false];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, post("".concat(apiUrl, "/events/").concat(eventId, "/invitees/").concat(inviteeId, "/rsvp"), {
                            response_status: 'DECLINED',
                        }, {
                            headers: __assign(__assign({}, tenantHeaders()), { 'content-type': 'application/json' }),
                            signal: abortControllerRef.current.signal,
                        })];
                case 2:
                    _b.sent();
                    return [2 /*return*/, true];
                case 3:
                    error_14 = _b.sent();
                    if (!isAbortError(error_14)) {
                        (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(t('errors.failed_to_update_invitee_rsvp_status', {
                            error: String(error_14),
                        })));
                    }
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [post, apiUrl, t, tenantHeaders]);
    var updateEvent = function (event, eventId, timezone, eventSeriesOption, updateAsSpace, recurrenceChanged) { return __awaiter(void 0, void 0, void 0, function () {
        var seriesOption, initialApiEvent, eventToUpdate, updatedEventResponse, error_15, rawMessage, isPersonalCalendarErr, displayMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setUpdatingEvent(true);
                    seriesOption = function () {
                        switch (eventSeriesOption) {
                            case EventSeriesOption.THIS_EVENT:
                                return '';
                            case EventSeriesOption.THIS_AND_FOLLOWING_EVENTS:
                                return '/series/this-and-following';
                            case EventSeriesOption.ALL_EVENTS:
                                return '/series';
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    setEventError(null);
                    return [4 /*yield*/, fetchEvent({ id: eventId, timezone: timezone })];
                case 2:
                    initialApiEvent = _a.sent();
                    if (!initialApiEvent) {
                        throw new Error('Event not found');
                    }
                    eventToUpdate = buildUpdateEventRequestBody(event, eventSeriesOption, recurrenceChanged);
                    return [4 /*yield*/, update("".concat(baseApiUrl, "/v2.0/events/").concat(eventId).concat(seriesOption()).concat(updateAsSpace ? '?as_space=true' : ''), eventToUpdate, {
                            headers: __assign(__assign({}, tenantHeaders()), { 'content-type': 'application/json' }),
                            method: 'PATCH',
                            signal: abortControllerRef.current.signal,
                        })];
                case 3:
                    updatedEventResponse = _a.sent();
                    if (!(event.attendeeCount !== undefined &&
                        (initialApiEvent === null || initialApiEvent === void 0 ? void 0 : initialApiEvent.reservation_approval) !== null)) return [3 /*break*/, 5];
                    return [4 /*yield*/, updateInviteeCount(eventId, event.attendeeCount)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: 
                // Perform the move operation if needed
                /* @TODO Add move endpoint when ability to move spaces is added */
                // if (needsMove && originalSpaceOrganizerId && newSpaceOrganizerId) {
                // return await moveEvent(
                //   event.id,
                //   originalSpaceOrganizerId,
                //   newSpaceOrganizerId
                // );
                // }
                return [2 /*return*/, {
                        data: updatedEventResponse.data,
                        meta: updatedEventResponse.meta,
                    }];
                case 6:
                    error_15 = _a.sent();
                    if (!isAbortError(error_15)) {
                        rawMessage = error_15 instanceof Error ? error_15.message : String(error_15);
                        isPersonalCalendarErr = isPersonalCalendarError(rawMessage);
                        displayMessage = isPersonalCalendarErr
                            ? t('errors.personal_calendar_required_for_request_only_space')
                            : t('errors.failed_to_update_event', { error: String(error_15) });
                        if (!abortControllerRef.current.signal.aborted) {
                            setEventError({
                                error: [displayMessage],
                                errorType: EventError.UPDATE,
                                isPersonalCalendarError: isPersonalCalendarErr,
                            });
                        }
                        throw error_15;
                    }
                    return [3 /*break*/, 8];
                case 7:
                    if (!abortControllerRef.current.signal.aborted) {
                        setUpdatingEvent(false);
                    }
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/, undefined];
            }
        });
    }); };
    /* @TODO Why doesn't this come back from the event Data...?? */
    var fetchEventSeries = useCallback(function (eventSeriesId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_16;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, get("".concat(apiUrl, "/events/").concat(eventSeriesId), undefined, { signal: abortControllerRef.current.signal })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_16 = _b.sent();
                    if (!isAbortError(error_16)) {
                        (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, new Error(t('errors.failed_to_fetch_event_series', {
                            error: String(error_16),
                        })));
                        throw error_16;
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, undefined];
            }
        });
    }); }, [get, apiUrl, t]);
    var getEventsBySpaceId = function (spaceId, startTime, endTime, apiUrl, accessToken, signal) { return __awaiter(void 0, void 0, void 0, function () {
        var params;
        return __generator(this, function (_a) {
            if (!apiUrl || !accessToken) {
                throw new Error(t('errors.api_url_and_access_token_required'));
            }
            params = new URLSearchParams({
                after: startTime,
                before: endTime,
                order_by: 'started_at',
                order_descending: 'false',
                page: '1',
                per_page: '100',
                use_experimental_index: 'true',
            });
            return [2 /*return*/, fetch("".concat(apiUrl, "/spaces/").concat(spaceId, "/events?").concat(params.toString()), {
                    method: 'GET',
                    signal: signal,
                    headers: {
                        Authorization: "Access-Token ".concat(accessToken),
                    },
                })
                    .then(function (response) {
                    return response.json();
                })
                    .then(function (data) {
                    return data.data;
                })];
        });
    }); };
    return {
        createEvent: createEvent,
        updateEvent: updateEvent,
        deleteEvent: deleteEvent,
        cancelEventAsSpace: cancelEventAsSpace,
        fetchEvent: fetchEvent,
        fetchSpace: fetchSpace,
        fetchEditSyncedEvents: fetchEditSyncedEvents,
        getVideoIntegration: getVideoIntegration,
        confirmEvent: confirmEvent,
        fetchLocationSettings: fetchLocationSettings,
        fetchEventSeries: fetchEventSeries,
        getEventsBySpaceId: getEventsBySpaceId,
        removeSpaceInvitee: removeSpaceInvitee,
        rsvpForInvitee: rsvpForInvitee,
        approveEventRequest: approveEventRequest,
        rejectEventRequest: rejectEventRequest,
        /* @TODO No distinction between create and update loading */
        composingEvent: creatingEvent || updatingEvent,
        eventError: eventError,
        setEventError: setEventError,
    };
};
